import { Table } from "react-bootstrap";
import { DateTime, Input, LocationCoordinates2, Sex } from "../../Client/ClientUtil";
import { useMemo, useRef, useState } from "react";
import { Message, SubmitClearButton } from "../../Login/LoginUtil";
import { validateCity, validateDouble, validateQuickName } from "../../Client/ClientValidate";
import { axiosErrorHandler, axiosGetWithHeader, axiosPostWithHeader } from "../../Common/axios";
import { useNavigate } from "react-router-dom";
import GLOBAL from "../../Common/Util";

export function QuickSearch()  {
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [birthTime, setBirthTime] = useState('');
    const [birthCity, setBirthCity] = useState('');
    const [birthLongitude, setBirthLongitude] = useState('');
    const [birthLatitude, setBirthLatitude] = useState('');
    const [sex, setSex] = useState('Male');
    const [firstName, setFirstName] = useState('');
    
    const birthDateReference = useRef();
    const birthTimeReference = useRef();
    const birthCityReference = useRef();
    const firstNameReference = useRef();
    
    const setMethod = { setFirstName, setBirthDate, setBirthTime, setBirthCity, setBirthLongitude, setBirthLatitude, setSex, setMessage };

    useMemo(() => {
        GLOBAL.isLoading=false;
    }, []);
    
    const handleInput = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        handleLocationInput(name, value);
    }
    
    const handleLocationInput = (name, value) => {
        switch(name) {
          case 'birthDate': setBirthDate(value); break;
          case 'birthTime': setBirthTime(value); break;
          case 'birthCity': setBirthCity(value); break;
          case 'birthLongitude': setBirthLongitude(value); break;
          case 'birthLatitude': setBirthLatitude(value); break;
          case 'sex': setSex(value); break;
          case 'firstName': setFirstName(value); break;
          case 'message': setMessage(value); break;
          default : 
        }
    }

    const handleReset = (event) =>{
        const value="";
        setBirthDate(value);
        setBirthTime(value);
        setBirthCity(value);
        setBirthLongitude(value);
        setBirthLatitude(value);
        setSex(value);
        setFirstName(value);
        setMessage(value);
        birthDateReference.current.focus();
      }  
        
    const handleSubmit =  (event) => {
        var msg = '';
        if(msg==='' && birthDate==="" ) {
            msg="Enter birth date";
            birthDateReference.current.focus();
        }
        if(msg==='' && birthTime==="" ) {
        msg="Enter birth time";
        birthTimeReference.current.focus();
        }
        if(msg==='') msg = validateCity(event,"birth place name",birthCityReference,birthCity);
        if(msg==='') {
            msg = validateDouble(event,"valid birth place name",birthCityReference,birthLatitude,-90,90);
            if(msg!=='') msg = msg +" or click <a href='/newclient.html'>here</a>";
        }
        if(msg==='') msg = validateDouble(event,"valid birth place name",birthCityReference,birthLongitude,-180,180);
        if(msg==='') msg = validateQuickName(event, firstNameReference,firstName,"name");
        setMessage(msg); 
        if(msg==='') {
            const data = {
              firstName: firstName,
              birthDate: birthDate,
              birthTime: birthTime+(birthTime.length===5?":00":""),
              birthTimezone: 5.5,
              birthCity: birthCity,
              birthLongitude: birthLongitude,
              birthLatitude: birthLatitude,
              sex: sex,
            }
            axiosPostWithHeader("/user/quickadd", data,
                (response)=>{
                    GLOBAL.isLoading=false;
                    if(response.data.code==='200') {
                        axiosGetWithHeader("/users/history/"+response.data.runningId, 
                            (response)=>{
                            console.log(response.message);
                            },
                            (error)=>{
                            console.log(error);
                            }
                        );
                        setTimeout(() => {
                            navigate('/kpastro.html', { state:{runningId:response.data.runningId}, replace: true });
                            navigate(0);
                        }, 100);              
                    }
                },
                (error)=>{
                    GLOBAL.isLoading=false;
                    setMessage(axiosErrorHandler(birthDateReference,error));
                }
            );
        }
        event.preventDefault();
    }
    return (
      <>
        <div class="m-2 p-0 row align-items-top content ">
            <div class="m-0 p-0 col-sm-12 col-md-12 text-center">
        <Table responsive border-none hover size="sm" className="caption-top m-0 p-0 ">
            <caption className="text-center">
                <h5>Quick View</h5>
            </caption>
        </Table>
        <div class="row m-0 p-0 w-100 border rounded">
            <div class="col m-0 p-0 justify-content-center">
                <Message msg={message} />
                <form method="post" onSubmit={handleSubmit}>
                <div class="row m-0 p-0 w-100">
                    <div class="col-sm-12 col-md-12 text-start">
                        <DateTime title1="Date of Birth * " title2="Time of Birth * " dateplaceholder="Birth Date" timeplaceholder="Birth Time" 
                        datename="birthDate" timename="birthTime" 
                        datereference={birthDateReference} timereference={birthTimeReference} 
                        datevalue={birthDate} timevalue={birthTime} callback={(event)=>handleInput(event,setMethod)} />
                        <LocationCoordinates2 
                            cityname="birthCity" citytitle="Place of Birth * " cityreference={birthCityReference} cityvalue={birthCity}
                            coordinatesname="" coordinatestitle="(Latitude, Longitude) "
                            longitudename="birthLongitude" latitudename="birthLatitude" 
                            longitudevalue={birthLongitude} latitudevalue={birthLatitude} 
                            callback={(event)=>handleInput(event,setMethod)}  callbacklocation={handleLocationInput} />
                        <Sex name="sex" title="Sex" data={sex} callback={(event)=>handleInput(event,setMethod)} />
                        <Input name="firstName" title="Name" placeholder="Name" reference={firstNameReference} data={firstName} callback={(event)=>handleInput(event,setMethod)} />
                        <SubmitClearButton callback={handleReset} />
                    </div>
                </div>
                </form>
            </div>
        </div>
        </div>
        </div>
      </>
    );
  }
  